import { NameValuePair } from '@components/Dashboard/CampaignAnalytics/slice/schema';
import { applyExtraAudienceYOffset } from './layout';
import { theme } from '@features/executive-report/domain/theme';
import { TextProps } from '@features/powerpoint';

export const extraAudienceToTextProps = (
  nameValuePair: NameValuePair,
  audienceIndex: number
): TextProps[] => [
  {
    text: nameValuePair.value.toString(),
    options: {
      fontSize: 11,
      color: theme.colors.inmarketGreen,
      align: 'center',
      h: 0.29,
      w: 0.54,
      x: 7.95,
      y: 2.39 + applyExtraAudienceYOffset(audienceIndex),
    },
  },
  {
    text: nameValuePair.name,
    options: {
      fontSize: 8,
      color: theme.colors.white,
      h: 0.2,
      w: 3.42,
      x: 8.38,
      y: 2.44 + applyExtraAudienceYOffset(audienceIndex),
    },
  },
];
